/* eslint-disable */
import { Card } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import AppHeader from "@saleor/components/AppHeader";
import Container from "@saleor/components/Container";
// import FilterBar from "@saleor/components/FilterBar";

import PageHeader from "@saleor/components/PageHeader";
import { emailSettingsList_emailSettings_edges_node } from "@saleor/emailTemplate/types/emailSettingsList";
import { sectionNames } from "@saleor/intl";
import { RotaryListUrlSortField } from "@saleor/rotary/urls";
import {
  FilterPageProps,
  ListActions,
  PageListProps,
  SortPage,
  TabPageProps
} from "@saleor/types";
import React from "react";
import { FormattedMessage } from "react-intl";

import EmailTemplateList from "../EmailTemplateList";
import { RotaryFilterKeys, RotaryListFilterOpts } from "./filters";

export interface RotaryListPageProps
  extends PageListProps,
    ListActions,
    FilterPageProps<RotaryFilterKeys, RotaryListFilterOpts>,
    SortPage<RotaryListUrlSortField>,
    TabPageProps {
  emailSettings: emailSettingsList_emailSettings_edges_node[];
  onBack: () => void;
}

const EmailTemplatePage: React.FC<RotaryListPageProps> = ({
  currencySymbol,
  filterOpts,
  initialSearch,
  onAdd,
  onBack,
  onFilterChange,
  onSearchChange,
  currentTab,
  onAll,
  onTabChange,
  onTabDelete,
  onTabSave,
  tabs,
  ...listProps
}) => {
  // const structure = createFilterStructure(intl, filterOpts);

  return (
    <Container>
      <AppHeader onBack={onBack}>
        <FormattedMessage {...sectionNames.configuration} />
      </AppHeader>
      <PageHeader title={"EmailTemplate"}>
        <Button onClick={onAdd} color="primary" variant="contained">
          <FormattedMessage
            defaultMessage="create default"
            description="button"
          />
        </Button>
      </PageHeader>
      <Card>
        {/* <FilterBar
          allTabLabel={intl.formatMessage({
            defaultMessage: "All Rotarys",
            description: "tab name"
          })}
          currencySymbol={currencySymbol}
          currentTab={currentTab}
          filterStructure={structure}
          initialSearch={initialSearch}
          searchPlaceholder={intl.formatMessage({
            defaultMessage: "Search Rotary"
          })}
          tabs={tabs}
          onAll={onAll}
          onFilterChange={onFilterChange}
          onSearchChange={onSearchChange}
          onTabChange={onTabChange}
          onTabDelete={onTabDelete}
          onTabSave={onTabSave}
        /> */}
        <EmailTemplateList {...listProps} />
      </Card>
    </Container>
  );
};
export default EmailTemplatePage;
